export default __webpack_public_path__ + "static/media/truck.08864d5f.svg";